/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { UsersListComp, Header, SettingsComp } from '../components';
import { useSMActual } from '../machines/pageContent';
import { useSMRevokeCredential } from '../machines/revokeCredential';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

import { SuppChainTransService } from '../services';
import { VApplication } from '@/application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.SuppChainTransService') as SuppChainTransService;
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const srv = getSrv();
  const [refreshPagination, setRefreshPagination] = useState(new Date());

  useEffect(() => {
    srv?.resetCriteria();
  }, []);

  const { actualPageMachine, actualPageSend, actualPageState } = useSMActual(
    {}
  );
  const {
    revokeCredentialMachine,
    revokeCredentialSend,
    revokeCredentialState,
  } = useSMRevokeCredential({});

  const onRevokeClick = (ids: any) => {
    revokeCredentialSend('START', {
      payload: ids,
    });
  };

  const onRefresh = () => {
    actualPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    actualPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotification = () => {
    if (revokeCredentialState?.matches('REVOKE_CREDENTIAL_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.revokeCredential || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    actualPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    return (
      <Paginate
        {...(actualPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={actualPageState?.event?.data?.value?.ultUsers?.length}
      />
    );
  };

  const onApplyFilter = (data: any) => {
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    actualPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const _renderPage = () => {
    if (actualPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.retrieveCredentials || {})}
        />
      );
    }

    if (revokeCredentialState?.matches('REVOKE_CREDENTIAL')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.revokeCredential || {})}
        />
      );
    }

    if (actualPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          {actualPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.credentialListEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(actualPageState?.event?.data?.value || {})}
              onViewDetailClick={props?.onViewDetailClick}
              onRevokeClick={onRevokeClick}
              onRowClick={props?.onViewDetailClick}
              onViewClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (actualPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.formSubmit || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
          <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
          {/* <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
      {_renderNotification()}
    </>
  );
};
